(function (angular) {

    'use strict';
    angular
        .module('app.errors')
        .controller('app.under-construction.controller', ['previousState', underConstructionController]);

    function underConstructionController(previousState) {
        var vm = this;
        vm.backUrl = previousState.name;
    }

})(angular);